<ng-template #expandedSponsor let-expandable="expandable" let-sponsor="sponsor">
  <div *ngIf="sponsors[sponsor.id] as sponsor" class="performer_container" [ngClass]="{open: expanded[sponsor.id]}">
    <div class="performer" [ngClass]="{can_expand: expandable}">
      <div class="head guy" (click)="!expandable ? null : expand($event, sponsor.id)">
        <div *ngIf="sponsor.logoUrl" class="guy-logo-holder" [ngClass]="{expanded: expanded[sponsor.id]}"> 
          <img class="guy-logo" [src]="sponsor.fullLogoUrl || sponsor.logoUrl">
        </div>
        <div class="details-expand-wrapper"><div class="details">
          <labels-view class="performer-labels" 
              *ngIf="(labelMap && sponsor.labels?.length && !sponsor.hideLabels) || (sponsor?.sponsorTypeId && sponsorTypes && sponsorTypes[sponsor.sponsorTypeId])" 
              [labelMap]="labelMap" 
              [labels]="sponsor.hideLabels ? [] : sponsor.labels"
              [sponsorType]="sponsor?.sponsorTypeId && sponsorTypes ? sponsorTypes[sponsor.sponsorTypeId] : null"
            ></labels-view>
          </div>
          <div style="flex:1;"></div>
          <div class="expand_arrow_container" *ngIf="expandable">
            <expand-icon [expanded]="expanded[sponsor.id]"></expand-icon>
          </div>
        </div>
  
      </div>
      <div class="body" [@drop]="allExpanded || expanded[sponsor.id] ? 'expand' : 'collapse'">
        <div class="sponsor-name">{{ sponsor.name }}</div>
        <social-links *ngIf="sponsor.social && sponsor.social.length" [socialLinks]="sponsor.social"></social-links>
<!--         <div *ngIf="sponsor.social && sponsor.social.length" class="social_links">
          <div class="social" *ngFor="let social of sponsor.social">
            <icon (click)="helpers.goToUrl($event, social.url)" [class]="'social_' + social.type.toLowerCase()" [icon]="'SOCIAL_' + social.type"></icon>
          </div>
        </div> -->
        <div *ngIf="sponsor.description" class="bio" [innerHTML]="helpers.strWithBreak(sponsor.description)"></div>
        <button *ngIf="sponsor.callToAction && sponsor.callToActionUrl" class="call-to-action" mat-button color="primary" (click)="helpers.goToUrl($event, sponsor.callToActionUrl)">{{ sponsor.callToAction | uppercase }}</button>
      </div>
    </div>
  </div>
</ng-template>

<div class="performers" *ngIf="(!hide || showEmpty) && sponsorIds?.length && !condensedSponsors">
  <h5 class="performer-title">{{sponsorsCustomTitle || 'SPONSORS'}}</h5>
  <ng-container *ngFor="let sponsorId of sponsorIds; trackBy: trackByItem">
    <ng-container *ngIf="sponsors[sponsorId] as sponsor" [ngTemplateOutlet]="expandedSponsor" [ngTemplateOutletContext]="{sponsor: sponsor, expandable: sponsor.description || (sponsor.social && sponsor.social.length) || (sponsor.callToAction && sponsor.callToActionUrl) || sponsor.name }"></ng-container>
  </ng-container>
</div>
<ng-container *ngIf="(!hide || showEmpty) && condensedSponsors">
  <h5 class="performer-title">{{sponsorsCustomTitle || 'SPONSORS'}}</h5>
  <ng-container *ngIf="{ sponsors: sponsorIds | idsToItems:sponsors } as vars;">
    <div class="sponsor-listing" *ngFor="let sponsor of vars.sponsors">
      {{ sponsor.name }}
    </div>
    <div *ngIf="!vars.sponsors.length" class="empty-text">No sponsors</div>
  </ng-container>
</ng-container>